<div class="c-welcomeBonusModal">
  <div
    #bgContainer
    class="c-welcomeBonusModal_background"
    theming
    themingGroup="none"
    [themingAsset]="'welcome-bonus-background-pl'">
    <div
      #juliet
      class="juliet">
      <slotcom-juliet-buddy
        [location]="'welcome-modal'"
        [pose]="welcomeModalPose"
        [hasDim]="true"></slotcom-juliet-buddy>
    </div>

    <div class="button-container">
      <div #secondButton>
        <slotcom-button
          class="c-button--pink closeButton"
          (safeClick)="handleClick()"
          audioType="reward">
          <span>{{ 'home.onboarding.welcome-cta' | translate | uppercase }}</span>
        </slotcom-button>
      </div>
    </div>
  </div>
</div>
